/** True when the document is at scroll top (including rubber-band / overscroll). */
export function isCcPageAtTopOverscroll(): boolean {
  return window.scrollY <= 0 && document.documentElement.scrollTop <= 0;
}

/** Sanjaya #services cards: progress 0→1 from top@viewport-bottom to bottom@viewport-bottom. */
export function heroBandCardFloatProgress(
  el: HTMLElement,
  viewportHeight = window.innerHeight,
): number {
  const { top, bottom } = el.getBoundingClientRect();
  const travel = bottom - top;
  if (travel <= 0) {
    return 0;
  }

  if (top >= viewportHeight || bottom <= 0) {
    return 0;
  }

  return Math.min(1, Math.max(0, (viewportHeight - top) / travel));
}

/**
 * During top overscroll, getBoundingClientRect shifts with rubber-band motion and
 * can spuriously drive float progress (opacity) toward 0 — hold the last value.
 */
export function heroBandCardFloatProgressWithPageTopGuard(
  el: HTMLElement,
  previousProgress: number | undefined,
  viewportHeight = window.innerHeight,
): number {
  const next = heroBandCardFloatProgress(el, viewportHeight);
  if (!isCcPageAtTopOverscroll() || previousProgress === undefined) {
    return next;
  }
  return Math.max(next, previousProgress);
}
